import { render, staticRenderFns } from "./DeveloperChapter.vue?vue&type=template&id=24b6e18e&"
import script from "./DeveloperChapter.vue?vue&type=script&lang=js&"
export * from "./DeveloperChapter.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperChapter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports